/**
 * Scan Agent - Edit Content Page
 * 
 * Route: /scan-agent/edit/:bookId
 * 
 * Wraps BookContentEditor for the scan-agent interface.
 */

import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { BookContentEditor } from '@/components/admin/BookContentEditor';

export function ScanAgentEditPage() {
  const { bookId } = useParams<{ bookId: string }>();
  const navigate = useNavigate();

  if (!bookId) {
    return (
      <div className="text-center py-12">
        <div className="text-[#8E8E93]">No book ID provided</div>
        <button
          onClick={() => navigate('/scan-agent')}
          className="mt-4 text-[#1A1A1A] text-sm"
        >
          Back to Queue
        </button>
      </div>
    );
  }

  return (
    <div className="h-[calc(100vh-8rem)] theme-admin bg-black rounded-xl overflow-hidden">
      <BookContentEditor
        bookId={bookId}
        onClose={() => navigate('/scan-agent')}
        onPublished={() => {
          setTimeout(() => navigate('/scan-agent'), 2000);
        }}
      />
    </div>
  );
}

export default ScanAgentEditPage;
